import { motion } from "framer-motion";
import { useLang } from "./LanguageContext";

const ease = [0.22, 1, 0.36, 1];

export const ReleaseCountdown = () => {
  const { t } = useLang();
  return (
    <section id="release" data-testid="release-section" className="relative py-28 md:py-36 bg-[#0C1326] border-y border-[#00F2FE]/15 overflow-hidden">
      <div className="absolute inset-0 stars opacity-50" />
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[60rem] h-[60rem] rounded-full bg-[#00F2FE]/10 blur-[120px]" />
      <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
        <p className="text-[#F9D423] text-xs font-bold tracking-[0.3em] mb-6">{t("release.overline")}</p>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease }}
          className="font-display font-black uppercase text-5xl sm:text-7xl lg:text-8xl leading-none text-[#00F2FE] drop-shadow-[0_0_35px_rgba(0,242,254,0.4)]"
        >
          {t("release.heading")}
        </motion.h2>

        <p className="mt-8 text-slate-300 text-base md:text-lg max-w-xl mx-auto leading-relaxed">{t("release.body")}</p>

        <a
          href="#newsletter"
          data-testid="release-wishlist-button"
          className="inline-block mt-10 bg-[#00F2FE] text-[#060A14] uppercase tracking-widest text-sm font-bold px-10 py-4 rounded-sm hover:bg-white shadow-[0_0_28px_rgba(0,242,254,0.45)] transition-all duration-300"
        >
          {t("release.wishlist")}
        </a>

        <p className="mt-10 font-mono-x text-sm text-slate-500 tracking-[0.25em]">{t("release.platforms")}</p>
      </div>
    </section>
  );
};

export default ReleaseCountdown;
